<div class="modal-header" ngxModalDraggable>
  <h4 class="modal-title">{{configuration?.Code}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="bsModalRef.dismiss()">
  </button>
</div>
<div class="modal-body">
  <app-configuration-data-edit [configuration]="configuration"
                               [readonly]="readonly"
                               [currentTab]="currentTab"
                               [shouldResetSaveState$]="shouldResetSaveState$"
                               [wasValidated$]="wasValidated$"
                               (setTab)="currentTab = $event"
                               (changed)="onChanged($event)"></app-configuration-data-edit>
</div>
<mes-web-edit-modal-buttons [entityId]="entityId"
                            [hasDeleteButton]="!!entityId"
                            [isPristine]="isPristine$ | async"
                            [displayName]="configuration?.Code"
                            (deleteClick)="delete()"
                            (saveClick)="save($event)"
                            (cancelClick)="bsModalRef.dismiss()">
</mes-web-edit-modal-buttons>
